var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b5433e93-35f8-4d81-8d6c-4a2484715d78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37.89 37.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-4ae68402-64f8-4486-84b5-b87a35f0e735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.89,
    height: 37.89,
    rx: 18.94,
    ry: 18.94,
    transform: "translate(37.89 37.89) rotate(-180)",
    style: {
      fill: "#f9f9f9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-666cd37d-c372-43ae-a47a-2c8fbecc17bc"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.89,
    height: 37.89,
    rx: 18.94,
    ry: 18.94,
    transform: "translate(37.89 37.89) rotate(-180)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#uuid-4ae68402-64f8-4486-84b5-b87a35f0e735)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 43.73,
    r: 18.41,
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 12.37,
    r: 9.2,
    style: {
      fill: "#a0a0a0"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.f3f7ba5732fe33ff5b04c1301aec6a92.svg";
export { ForwardRef as ReactComponent };